module.exports = __webpack_public_path__ + "img/web.18382683.svg";